module.exports = __webpack_public_path__ + "img/img-apply.1ce60eb6.svg";